import {BasePageRequest} from './BasePageRequest';

export class PortalUserSearchRequest extends BasePageRequest {

    name: string;
    surname: string;
    active: number;

    constructor(pageNumber?: any, size?: any, name?: any, surname?: any, active?: number) {
        super(pageNumber, size, null, null);
        this.name = name;
        this.surname = surname;
        this.active = active;
    }
}
